/**
 * Story 8.12 — Onglet Équipe en lecture seule (modale profil membre)
 * Affiche la liste des membres de l'équipe avec nom, email, fonction.
 * Pas d'actions (ajout, suppression, reset password).
 */
import React from 'react';
import type { ProfileData } from '../../../../../services/profileService';

interface TeamMember {
    id: number;
    nom: string;
    prenom: string;
    email: string;
    telephone: string;
    fonction: string;
    role: string;
    is_admin: boolean;
}

interface ProfileDataWithTeam extends ProfileData {
    team?: TeamMember[];
}

interface ReadOnlyEquipeProps {
    data: ProfileData;
}

const ReadOnlyEquipe: React.FC<ReadOnlyEquipeProps> = ({ data }) => {
    const team = (data as ProfileDataWithTeam).team ?? [];

    return (
        <div className="readonly-tab readonly-equipe">
            <section className="readonly-section">
                <div className="readonly-section-title">Membres de l'équipe</div>

                {team.length === 0 ? (
                    <p className="readonly-empty">Aucun membre dans l'équipe.</p>
                ) : (
                    <table className="readonly-team-table">
                        <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th>Email</th>
                                <th>Téléphone</th>
                                <th>Fonction</th>
                                <th>Rôle</th>
                            </tr>
                        </thead>
                        <tbody>
                            {team.map((member) => (
                                <tr key={member.id}>
                                    <td>{member.nom || '-'}</td>
                                    <td>{member.prenom || '-'}</td>
                                    <td>{member.email || '-'}</td>
                                    <td>{member.telephone || '-'}</td>
                                    <td>{member.fonction || '-'}</td>
                                    <td>
                                        <span className={`readonly-role-badge ${member.is_admin ? 'admin' : 'member'}`}>
                                            {member.role}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </section>
        </div>
    );
};

export default ReadOnlyEquipe;
